import React, { useState } from "react";
import { useSelector } from "react-redux";

const ProfilePersonlyForm = () => {
  const { username, militaryNumber } = useSelector((state) => state.user);

  return (
    <form action="">
      <div className="bottom">
        <div className="image">
          <img src="/assets/images/logo-light.jfif" alt="avatar" />
        </div>

        <div className="form">
          <div className="from-group">
            <label htmlFor="">اسم المستخدم</label>
            <div className="input-group">
              <img src="/assets/icons/icon-profile.svg" alt="" />
              <input type="text" value={username} disabled />
            </div>
          </div>
          <div className="from-group">
            <label htmlFor="">الرقم العسكري</label>
            <div className="input-group">
              <img src="/assets/icons/fi_tablet.png" alt="" />
              <input type="number" value={militaryNumber} disabled />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ProfilePersonlyForm;
